export const CART_STATUS = {
  SAVED: 'SAVED',
  PENDING: 'SUBMITTED_PENDING_REVIEW'
};

export const TIMEOUT_ERROR_CODE = '500';

export const NO_ERROR_MESSAGE = 'NONE';
export const SUCCESS_MESSAGE = 'SUCCESS';

export const CHECKOUT_REGULAR = 0;
export const CHECKOUT_FOR_APPROVAL = 1;
export const CHECKOUT_CANCEL = 2;
